export const NotificationsGetters = {
  notificationsList: state => state.notificationsList,
  recentUnreadNotifications: state => state.recentUnreadNotifications,
  totalNotificationsCount: state => state.totalNotificationsCount,
  unreadNotificationsCount: state => state.unreadNotificationsCount,
}
